export const TIMEZONE_OPTIONS = [
  { value: "Asia/Istanbul", label: "(+03:00) — Asia/Istanbul" },
  { value: "Europe/Moscow", label: "(+03:00) — Europe/Moscow" },
  { value: "Asia/Dubai", label: "(+04:00) — Asia/Dubai" },
  { value: "Asia/Aqtau", label: "(+05:00) — Asia/Aqtau" },
  { value: "Asia/Almaty", label: "(+06:00) — Asia/Almaty" },
];
